<!-- User Info/Edit Modal -->
<form
  #f="ngForm"
  (ngSubmit)="saveClicked(f)"
  name="user-profile-form"
  style="overflow-y: auto"
  mdbModal
  #newUserModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
  [config]="{ ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">New User</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Personal Information</p>
          </div>
          <!-- Full name -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.fullName"
              mdbInput
              mdbValidate
              name="fullName"
              type="text"
              id="newUserFullName"
              class="form-control"
              #fullName="ngModel"
              required
            />
            <label for="newUserFullName">Full name</label>
            <mdb-error *ngIf="fullName.invalid && (fullName.dirty || fullName.touched)">First name is required </mdb-error>
            <mdb-success *ngIf="fullName.valid && (fullName.dirty || fullName.touched)"></mdb-success>
          </div>

          <!-- Display name -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.displayName"
              mdbInput
              mdbValidate
              name="displayName"
              type="text"
              id="newUserDisplayName"
              class="form-control"
              #displayName="ngModel"
              required
            />
            <label for="newUserDisplayName">Display name</label>
            <mdb-error *ngIf="displayName.invalid && (displayName.dirty || displayName.touched)">Last name is required </mdb-error>
            <mdb-success *ngIf="displayName.valid && (displayName.dirty || displayName.touched)"> </mdb-success>
          </div>

          <!-- E-mail -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.email"
              mdbInput
              mdbValidate
              name="email"
              type="text"
              id="newUserEmail"
              autocomplete="email"
              class="form-control"
              #email="ngModel"
              required
              [pattern]="regexForEmail"
            />
            <label for="newUserEmail">E-mail</label>
            <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Email address not valid </mdb-error>
            <mdb-success *ngIf="email.valid && (email.dirty || email.touched)"></mdb-success>
          </div>

          <!--Physical Address-->
          <!--
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.physicalAddress"
              mdbInput
              mdbValidate
              name="physicalAddress"
              type="text"
              id="physicalAddress"
              class="form-control"
              #physicalAddress="ngModel"
              maxlength="500"
            />
            <label for="physicalAddress">Physical Address</label>
          </div>
          -->

          <!-- Cellphone -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.mobile"
              mdbInput
              mdbValidate
              name="mobile"
              type="text"
              id="newUserMobile"
              class="form-control"
              #mobile="ngModel"
              required
              pattern="^0?\+?\d{1,3} ?\d{2} ?\d{3} ?\d{4}$"
              placeholder="+27 xxxxxxxxx"
            />
            <label for="newUserMobile">Cellphone</label>
            <mdb-error *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)">Cellphone number not valid </mdb-error>
            <mdb-success *ngIf="mobile.valid && (mobile.dirty || mobile.touched)"></mdb-success>
          </div>

          <!-- ID Number -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.idNumber"
              mdbInput
              mdbValidate
              name="idNumber"
              type="text"
              id="newUserIdNumber"
              class="form-control"
              #idNumber="ngModel"
              placeholder="South African ID Number"
              (blur)="CheckIfIdInUse()"
              [class.ng-invalid]="idNumberInUse"
            />
            <label for="newUserIdNumber">ID Number</label>
            <mdb-error *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)">ID number not valid </mdb-error>
            <mdb-error *ngIf="idNumberInUse">Id Number already in use</mdb-error>
            <mdb-success *ngIf="idNumber.valid && (idNumber.dirty || idNumber.touched)"></mdb-success>
          </div>

          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Banking Details</p>
          </div>

          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.accountNumber"
              mdbInput
              mdbValidate
              name="bankAccountNumber"
              type="number"
              id="newUserBankAccountNumber"
              class="form-control"
              #bankAccountNumber="ngModel"
            />
            <label for="newUserBankAccountNumber">Account Number</label>
            <mdb-error *ngIf="bankAccountNumber.invalid && (bankAccountNumber.dirty || bankAccountNumber.touched)"
              >Account Number</mdb-error
            >
            <mdb-success *ngIf="bankAccountNumber.valid && (bankAccountNumber.dirty || bankAccountNumber.touched)"></mdb-success>
          </div>

          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.cifNumber"
              mdbInput
              mdbValidate
              name="cifNumber"
              type="number"
              id="cifNumber"
              class="form-control"
              #cifNumber="ngModel"
            />
            <label for="cifNumber">CIF Number</label>
            <mdb-error *ngIf="cifNumber.invalid && (cifNumber.dirty || cifNumber.touched)">Client Number</mdb-error>
            <mdb-success *ngIf="cifNumber.valid && (cifNumber.dirty || cifNumber.touched)"></mdb-success>
          </div>

          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Sars Details</p>
          </div>

          <!-- Income Tax ref number -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.incomeTaxNumber"
              mdbInput
              mdbValidate
              name="incomeTaxReferenceNumber"
              type="text"
              id="newUserIncomeTaxReferenceNumber"
              class="form-control"
              #incomeTaxReferenceNumber="ngModel"
            />
            <label for="newUserIncomeTaxReferenceNumber">Income Tax Reference Number</label>
            <mdb-error *ngIf="incomeTaxReferenceNumber.invalid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
              Income Tax Reference number not valid</mdb-error
            >
            <mdb-success *ngIf="incomeTaxReferenceNumber.valid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
            </mdb-success>
          </div>

          <!-- Sars Username -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.sarsUsername"
              mdbInput
              mdbValidate
              name="sarsUsername"
              type="text"
              id="newUserSarsUsername"
              class="form-control"
              #sarsUsername="ngModel"
            />
            <label for="newUserSarsUsername">Sars Login Username</label>
            <mdb-error *ngIf="sarsUsername.invalid && (sarsUsername.dirty || sarsUsername.touched)"
              >Sars Login Username not valid</mdb-error
            >
            <mdb-success *ngIf="sarsUsername.valid && (sarsUsername.dirty || sarsUsername.touched)"> </mdb-success>
          </div>

          <!-- Sars Password -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="userDetails.sarsPassword"
              mdbInput
              mdbValidate
              name="sarsPassword"
              type="text"
              id="newUserSarsPassword"
              class="form-control"
              #sarsPassword="ngModel"
            />
            <label for="newUserSarsPassword">Sars Login Password</label>
            <mdb-error *ngIf="sarsPassword.invalid && (sarsPassword.dirty || sarsPassword.touched)"
              >Sars Login Password not valid</mdb-error
            >
            <mdb-success *ngIf="sarsPassword.valid && (sarsPassword.dirty || sarsPassword.touched)"> </mdb-success>
          </div>
        </div>
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="modal-footer justify-content-right">
          <button *ngIf="!busy" type="submit" mdbBtn color="trakly-action" class="relative waves-light">Save</button>
          <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
